.root {
  max-width: 1400px;
}

.fullWidth {
  max-width: none;
}

.center {
  margin: 0 auto;
}

.padding-regular {
  padding: 0 var(--page-x-padding-mobile);

  @media (--md-up) {
    padding: 0 var(--page-x-padding);
  }
}

.article {
  max-width: 750px;
}
